<template>
  <title-container title="Account Settings" icon="sliders-h">
    <settings-tabs :index="tabIndex" />
  </title-container>
</template>

<script>
import TitleContainer from '@/components/utils/TitleContainer';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import SettingsTabs from '@/components/settings/tabs/SettingsTabs';

library.add(faSlidersH);
export default {
  components: {
    SettingsTabs,
    TitleContainer,
  },
  computed: {
    tabIndex() {
      return this.$route.query.tab || 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/SettingsPage.vue